import React from 'react';
import { Drawer, Col, Table } from 'antd';
import {
	Chart as ChartJS,
	CategoryScale,
	LinearScale,
	PointElement,
	LineElement,
	Title,
	Tooltip,
	Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
// import { Chart as ChartJS } from 'chart.js/auto';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const GeneratedReport = ({ visible, onClose, data, record }) => {
	const columns = [
		{
			title: 'DATE',
			dataIndex: 'date',
			width: 150,
			text: 'center',
		},
		{
			title: 'RESULT INTERPRETATION',
			dataIndex: 'resultInterpretation',
			width: 150,
		},
		{
			title: 'MED TECH',
			dataIndex: 'medtech',
			width: 150,
		},
	];

	const content = {
		labels: data.map(item => item.date),
		datasets: [
			{
				label: 'Users Gained',
				data: data.map(item => item.resultInterpretation),
				backgroundColor: ['rgba(75,192,192,1)', '#ecf0f1', '#50AF95', '#f3ba2f', '#2a71d0'],
				borderColor: 'No. of Days',
				borderWidth: 2,
			},
		],
	};

	console.log(record);

	return (
		<Drawer
			title={`LOT NO. ${record ? record.lotno : null} | ${record ? record.sectionname : null} | ${
				record ? record.examname : null
			} | ${record ? record.levelname : null} | ${record ? record.level : null}`}
			// title={`LOT NO. 882000 | HEMATOLOGY | RBC | LEVEL NAME | LEVEL`}
			width="95%"
			placement="right"
			closable
			onClose={() => onClose(false)}
			visible={visible}
			className="quality-control-generatedReport-container"
		>
			<div className="header">
				<p className="font-sm leading-botton-0 leading-none">ANALYZER EXAM CODE</p>
				<div className="header-value">
					<p className="font-sm leading-botton-0 leading-none">LSL VALUE : 5.22 x 10/uL</p>
					<p className="font-sm leading-botton-0 leading-none">EV VALUE : 5.40 x 10/uL</p>
					<p className="font-sm leading-botton-0 leading-none">USL VALUE : 5.40 x 10/uL</p>
				</div>
			</div>
			<div className="space-y-md"></div>
			<Col className="chart">
				<Line
					data={content}
					options={{
						maintainAspectRatio: false,
					}}
				/>
			</Col>
			<div className="space-y-md"></div>
			<Table style={{ marginTop: '10px' }} pagination={false} columns={columns} dataSource={data} />
		</Drawer>
	);
};

export default GeneratedReport;
